import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Sparkles, Loader2, Target } from 'lucide-react';

export function AIDialog({ open, onOpenChange, prompt, onPromptChange, loading, onGenerate }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>AI Content Generator</DialogTitle>
          <DialogDescription>Describe what you want to generate and AI will create it for you.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Textarea data-testid="ai-prompt-input" value={prompt} onChange={(e) => onPromptChange(e.target.value)} rows={4} placeholder="Describe what you want to generate..." className="rounded-none border border-slate-200" />
          <Button data-testid="ai-generate-btn" onClick={onGenerate} disabled={loading} className="w-full bg-[#FB923C] hover:bg-orange-300 text-slate-900 font-bold rounded-none px-6 py-3">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Sparkles className="w-4 h-4 mr-2" />} Generate
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function ATSResultDisplay({ result }) {
  if (!result) return null;
  const DEFAULT_SCORE = 70;
  const score = result.score || DEFAULT_SCORE;
  let label = 'Needs work';
  let color = 'text-red-600';
  if (score >= 70) { label = 'Strong match'; color = 'text-emerald-600'; }
  else if (score >= 50) { label = 'Decent match'; color = 'text-amber-600'; }

  return (
    <div data-testid="ats-result" className="bg-slate-50 border border-slate-200 p-6 space-y-3">
      <div className="text-center">
        <div className="text-6xl font-black text-[#FB923C] mb-1">{score}%</div>
        <p className="text-sm text-slate-600">ATS Compatibility Score</p>
        <p className={`text-xs font-bold mt-1 ${color}`}>{label}</p>
      </div>
      <p className="text-xs text-slate-500 text-center pt-2 border-t border-slate-200">
        Want missing keywords + AI-optimized suggestions? Use <span className="font-semibold text-slate-900">Optimize</span> from the toolbar.
      </p>
    </div>
  );
}

export function ATSDialog({ open, onOpenChange, jobDescription, onJobDescriptionChange, loading, onCheck, result }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>ATS Score Checker</DialogTitle>
          <DialogDescription>Paste a job description to check how well your resume matches.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Textarea data-testid="job-description-input" value={jobDescription} onChange={(e) => onJobDescriptionChange(e.target.value)} rows={6} placeholder="Paste the job description here..." className="rounded-none border border-slate-200" />
          <Button data-testid="calculate-ats-btn" onClick={onCheck} disabled={loading || !jobDescription} className="w-full bg-[#FB923C] hover:bg-orange-300 text-slate-900 font-bold rounded-none px-6 py-3">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Target className="w-4 h-4 mr-2" />} Calculate ATS Score
          </Button>
          <ATSResultDisplay result={result} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
